import { get } from 'lodash/fp'
import { combine, withContext } from 'react-hooks-combine'

import { StoreContext } from 'store/context'
import { profile } from 'routes/route.map'

import MenuComponent from './component'

export default combine({
  hooks: [
    withContext('loggedEntity', StoreContext, get('auth.loggedEntity')),
    withContext('appConfig', StoreContext, ({ appConfig }) => appConfig),
  ],

  transformProps: ({ loggedEntity, className, appConfig }) => {
    const isBeneAndSponsorFlow =
      loggedEntity?.isBeneficiary || loggedEntity?.isSponsor
    const menuItemsAvailable = [
      {
        title: 'Profile',
        icon: ['far', 'user'],
        path: profile.index(),
      },
      {
        title: 'InWins',
        icon: 'trophy',
        path: profile.inwins(),
      },
      {
        title: 'Beneficiaries',
        icon: 'users',
        path: profile.beneficiaries(),
      },
      {
        title: 'Athletes',
        icon: 'dumbbell',
        path: profile.athletes(),
      },
      {
        title: 'Teams',
        icon: 'users',
        path: profile.teams(),
      },
      {
        title: 'Tournaments',
        icon: 'trophy',
        path: profile.tournaments(),
      },
    ]

    if (isBeneAndSponsorFlow) {
      return {
        className,
        items: [menuItemsAvailable[0]],
        appConfig,
      }
    }

    return {
      className,
      items: menuItemsAvailable,
      appConfig,
    }
  },
})(MenuComponent)
